import AuditLogs from "./AuditLogs";

const GenericAuditLogs = () => (
  <AuditLogs
    includeOrganizationIdentifier={false}
    title="Audit Logs"
  />
);

export default GenericAuditLogs;
